module.exports = __webpack_public_path__ + "static/media/pasamosagosto1.67687801.jpg";